<template>
  <div class="e-close-badge" v-on="$listeners">
    <span class="icon-close-sign" />
  </div>
</template>
<script>
export default {
  name: 'ECloseBadge',
}
</script>
